import { useCallbacksStorage, CallbackId } from '@/modules/viewer/composables/useCallbacksStorage';

export const useItemDuplicate = () => {
  const handleDuplicated = ({ storageKey, redirectUrl }: { storageKey?: string; redirectUrl: string }) => {
    if (storageKey) {
      useCallbacksStorage().set(storageKey, CallbackId.OPEN_TOAST_COPIED_SHARE_SETTINGS);
    }
    window.open(redirectUrl, '_self');
  };

  return { handleDuplicated };
};
